import Link from '@atlaskit/link';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import lessBoldLight from "../../../../src/pages/foundations/content/voice-tone/_assets/voice-and-tone-less-bold-light.png";
import lessBoldDark from "../../../../src/pages/foundations/content/voice-tone/_assets/voice-and-tone-less-bold-dark.png";
import moreBoldLight from "../../../../src/pages/foundations/content/voice-tone/_assets/voice-and-tone-more-bold-light.png";
import moreBoldDark from "../../../../src/pages/foundations/content/voice-tone/_assets/voice-and-tone-more-bold-dark.png";
import lessOptimisticLight from "../../../../src/pages/foundations/content/voice-tone/_assets/voice-and-tone-less-optimistic-light.png";
import lessOptimisticDark from "../../../../src/pages/foundations/content/voice-tone/_assets/voice-and-tone-less-optimistic-dark.png";
import moreOptimisticLight from "../../../../src/pages/foundations/content/voice-tone/_assets/voice-and-tone-more-optimistic-light.png";
import moreOptimisticDark from "../../../../src/pages/foundations/content/voice-tone/_assets/voice-and-tone-more-optimistic-dark.png";
import lessWinkyLight from "../../../../src/pages/foundations/content/voice-tone/_assets/voice-and-tone-less-winky-light.png";
import lessWinkyDark from "../../../../src/pages/foundations/content/voice-tone/_assets/voice-and-tone-less-winky-dark.png";
import moreWinkyLight from "../../../../src/pages/foundations/content/voice-tone/_assets/voice-and-tone-more-winky-light.png";
import moreWinkyDark from "../../../../src/pages/foundations/content/voice-tone/_assets/voice-and-tone-more-winky-dark.png";
import * as React from 'react';
export default {
  Link,
  SectionMessage,
  SectionMessageAction,
  lessBoldLight,
  lessBoldDark,
  moreBoldLight,
  moreBoldDark,
  lessOptimisticLight,
  lessOptimisticDark,
  moreOptimisticLight,
  moreOptimisticDark,
  lessWinkyLight,
  lessWinkyDark,
  moreWinkyLight,
  moreWinkyDark,
  React
};